import logo from './logo.svg';
import './App.css';
import Home from './page/Home';
import Layout from "../src/component/Layout"
import Product from './component/Products';
import FooterBanner from './component/FooterBanner';

function App() {
  return (
        <div>
          <Layout>
          <FooterBanner />
           
             </Layout>
        </div>
         
 
  );
}

export default App;
